import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";

const ViewIndividualMemberServiceApi = createApi({
    reducerPath: 'ViewIndividualMemberServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getIndividualDetailsbyId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetIndividualDetailsbyId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //Mutation to get Individual Member List
        getViewIndividualMemberList: builder.mutation({
            query: (details) => ({
                url: `/Membership/GetViewIndividualMemberList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        editIPASMemberDetails: builder.mutation({
            query: (details) => ({
                url: `/Membership/EditIPASMemberDetails`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getFinancialInformationById: builder.mutation({
            query: (details) => ({
                url: `/Membership/GetIPASMembersFinancialInformationById`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        generatePDFForIndividualMember: builder.query({
            query: (details) => ({
                url: (`/Membership/GeneratePDFForIndividualMember?id=${encryptAES(details.id)}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetBookingListForIndividualMemberById: builder.mutation({
            query: (details) => ({
                url: `/Membership/GetBookingListForIndividualMemberById`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GenerateCreditNoteForBooking: builder.mutation({
            query: (details) => ({
                url: `/Membership/GenerateCreditNoteForBooking`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        cancelInvoiceForIndividualMembership: builder.mutation({
            query: (details) => ({
                url: `/Membership/CancelInvoiceForIndividualMembership`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendRenewalMailManually: builder.mutation({
            query: (details) => ({
                url: '/Membership/SendRenewalMailManually',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetIndividualDetailsForUpgrademembershipbyId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetIndividualDetailsForUpgrademembershipbyId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        EditUpgradeMemberDetails: builder.mutation({
            query: (details) => ({
                url: `/Membership/EditUpgradeMemberDetails`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetIndividualDetailsbyIdQuery,
    useGetViewIndividualMemberListMutation,
    useEditIPASMemberDetailsMutation,
    useGetFinancialInformationByIdMutation,
    useLazyGeneratePDFForIndividualMemberQuery,
    useGetBookingListForIndividualMemberByIdMutation,
    useGenerateCreditNoteForBookingMutation,
    useCancelInvoiceForIndividualMembershipMutation,
    useSendRenewalMailManuallyMutation,
    useLazyGetIndividualDetailsForUpgrademembershipbyIdQuery,
    useEditUpgradeMemberDetailsMutation,
} = ViewIndividualMemberServiceApi;

export default ViewIndividualMemberServiceApi;